import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import './SignupPage.css';
import signupBg from '../assets/history2/Middle_Ages_-_Medieval_Europe.png';

export default function SignupPage() {
  const [form, setForm] = useState({
    email: '',
    display_name: '',
    first_name: '',
    last_name: '',
    age: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      // 1) Create the user
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/register/`,
        {
          username: form.email,
          email: form.email,
          display_name: form.display_name,
          first_name: form.first_name,
          last_name: form.last_name,
          age: form.age,
          password: form.password,
        }
      );

      // 2) Immediately get JWT tokens
      const { data: tokenData } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/token/`,
        {
          username: form.email,
          password: form.password,
        }
      );

      // 3) Store and set default Authorization header
      localStorage.setItem('access_token', tokenData.access);
      localStorage.setItem('refresh_token', tokenData.refresh);
      axios.defaults.headers.common['Authorization'] = `Bearer ${tokenData.access}`;

      // 4) Redirect wherever you like
      navigate('/campfirepage');
    } catch (err) {
      console.error('Registration or token error', err);
      if (err.response?.data) {
        setError(JSON.stringify(err.response.data));
      } else {
        setError('An unexpected error occurred.');
      }
    }
  };

  return (
    <div
      className="signup-container"
      style={{ backgroundImage: `url(${signupBg})` }}
    >
      <div className="signup-header">
        <a href="/Home" className="signup-header-btn">Home</a>
        <a href="/signin" className="signup-header-btn">Sign In</a>
      </div>

      <form className="signup-form" onSubmit={handleSubmit}>
        <h2>Create Your Account</h2>
        {error && <div className="error-msg">{error}</div>}

        <label>Email
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </label>

        <label>Display Name
          <input
            type="text"
            name="display_name"
            value={form.display_name}
            onChange={handleChange}
            required
          />
        </label>

        <label>First Name
          <input
            type="text"
            name="first_name"
            value={form.first_name}
            onChange={handleChange}
          />
        </label>

        <label>Last Name
          <input
            type="text"
            name="last_name"
            value={form.last_name}
            onChange={handleChange}
          />
        </label>

        <label>Age
          <input
            type="number"
            name="age"
            value={form.age}
            onChange={handleChange}
          />
        </label>

        <label>Password
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            required
          />
        </label>

        <label>Confirm Password
          <input
            type="password"
            name="confirmPassword"
            value={form.confirmPassword}
            onChange={handleChange}
            required
          />
        </label>

        <button type="submit" className="btn-submit">Sign Up</button>
      </form>
    </div>
  );
}
